document.addEventListener('DOMContentLoaded', () => {
  const heroes = document.querySelectorAll('[data-hero]');

  heroes.forEach((hero) => {
    const bg = hero.querySelector('[data-hero-bg]');
    const cue = hero.querySelector('[data-scroll-cue]');
    const atcForm = hero.querySelector('[data-hero-atc]');

    // Initial load animation
    requestAnimationFrame(() => {
      hero.classList.add('is-loaded');
    });

    // Scroll-driven image scale and cue fade
    let hasScrolled = false;
    const maxScroll = 600;

    const onScroll = () => {
      const scrollY = window.scrollY;
      const progress = Math.min(scrollY / maxScroll, 1);

      if (bg) {
        const scale = 1.06 - (0.06 * progress);
        bg.style.transform = `scale(${scale})`;
      }

      if (scrollY > 10 && !hasScrolled) {
        hasScrolled = true;
        cue?.classList.add('is-hidden');
      }
    };

    window.addEventListener('scroll', () => {
      window.requestAnimationFrame(onScroll);
    }, { passive: true });

    onScroll();

    // Add to cart: opens and updates the cart drawer
    if (atcForm) {
      atcForm.addEventListener('submit', (event) => {
        event.preventDefault();
        const submitButton = atcForm.querySelector('button[type="submit"]');
        window.lhLandingsAddToCart(atcForm, submitButton);
      });
    }
  });
});
